/**图片懒加载，预加载一个视口的图片资源 */
function lazyload(el, src) {
  /**可视区域高度 */
  let viewHeight = document.documentElement.clientHeight;
  let rect = el.getBoundingClientRect();
  rect.bottom >= 0 && rect.top < viewHeight * 2 ? changeImgSrc(el, src) : "";
  document.addEventListener("scroll", function() {
    let rect1 = el.getBoundingClientRect();
    rect1.bottom >= 0 && rect1.top < viewHeight * 2
      ? changeImgSrc(el, src)
      : "";
  });
}

/**将el的src加上 */
function changeImgSrc(el, src) {
  if (el.src == "") {
    console.log(el.src);
    el.src = src;
  } else {
    //
  }
}

module.exports = lazyload;
